<template>
    <div class="or-category-card anim-scale hover-pointer">
        <img class="image" :src="options.image"/>
        <div class="text flex-column flex-center anim-category-card"> 
            <p class="name">{{options.name}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: Object,
    },
}
</script>

<style scoped>
    .or-category-card {
        width: 575px;
        height: 316px;
        background-color: #1e1e1e;
        border-radius: 8px;
        overflow: hidden;
    }
    .image {
        width: 575px;
        height: 200px;
        object-fit: cover;
        object-position: center;
    }
    .text {
        widows: 575px;
        height: 116px;
        color: #FFFFFF;
    }
    .name {
        font-size: 24px;
        line-height: 29px;
        text-align: center;
    }
</style>